(function () {
  "use strict";
  if (window.__pfandNestedCart) return;
  window.__pfandNestedCart = true;

  const CONFIG = window.pfandDepositConfig || null;

  function numericId(gid) {
    const last = String(gid == null ? "" : gid).split("/").pop();
    const n = Number(last);
    return Number.isFinite(n) ? n : null;
  }

  const rulesByParent = {};
  const depositProductIds = {};
  if (CONFIG && CONFIG.enabled && Array.isArray(CONFIG.rules)) {
    CONFIG.rules.forEach(function (rule) {
      const parent = numericId(rule && rule.parentProductId);
      const depositVariant = numericId(rule && rule.depositVariantId);
      const depositProduct = numericId(rule && rule.depositProductId);
      const units = Math.max(1, Math.round(Number(rule && rule.unitsPerParent) || 0));
      if (!parent || !depositVariant || !depositProduct) return;
      rulesByParent[parent] = {
        depositVariantId: depositVariant,
        depositProductId: depositProduct,
        unitsPerParent: units,
      };
      depositProductIds[depositProduct] = true;
    });
  }

  if (!Object.keys(rulesByParent).length) return;

  const RELOAD_FLAG = "pfand:reloaded";
  const MAX_PASSES = 6;

  let running = false;
  let pending = false;
  let debounceTimer = null;

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) { return res.json(); });
  }

  function postCart(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (data) {
        if (!res.ok) {
          const reason = (data && (data.description || data.message)) || res.statusText;
          const error = new Error("Cart API " + res.status + " on " + url + " — " + reason);
          error.body = data;
          throw error;
        }
        return data;
      });
    });
  }

  function depositChildrenOf(items, parentKey, depositProductId) {
    return items.filter(function (it) {
      return it.product_id === depositProductId &&
        it.parent_relationship &&
        it.parent_relationship.parent_key === parentKey;
    });
  }

  function readFlag(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function writeFlag(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) {}
  }
  function clearFlag(key) {
    try { sessionStorage.removeItem(key); } catch (e) {}
  }

  function buildPlan(cart) {
    const items = (cart && cart.items) || [];
    const adds = [];
    const updates = {};

    items.forEach(function (line) {
      const rule = rulesByParent[line.product_id];
      if (!rule || line.parent_relationship) return;
      const wanted = line.quantity * rule.unitsPerParent;
      const children = depositChildrenOf(items, line.key, rule.depositProductId);

      if (!children.length) {
        adds.push({ id: rule.depositVariantId, quantity: wanted, parent_line_key: line.key });
        return;
      }

      if (children[0].quantity !== wanted) updates[children[0].key] = wanted;
      children.slice(1).forEach(function (extra) { updates[extra.key] = 0; });
    });

    items.forEach(function (dep) {
      if (!depositProductIds[dep.product_id]) return;
      const parentKey = dep.parent_relationship && dep.parent_relationship.parent_key;
      const validParent = parentKey && items.some(function (it) {
        return it.key === parentKey && rulesByParent[it.product_id];
      });
      if (!validParent) updates[dep.key] = 0;
    });

    return { adds: adds, updates: updates };
  }

  function applyPlan(plan) {
    if (Object.keys(plan.updates).length) {
      return postCart("/cart/update.js", { updates: plan.updates }).then(function () { return true; });
    }
    if (plan.adds.length) {
      return postCart("/cart/add.js", { items: [plan.adds[0]] }).then(function () { return true; });
    }
    return Promise.resolve(false);
  }

  async function reconcile() {
    if (running) {
      pending = true;
      return;
    }
    running = true;

    let changed = false;
    let converged = false;

    try {
      for (let pass = 0; pass < MAX_PASSES; pass++) {
        const applied = await applyPlan(buildPlan(await getCart()));
        if (!applied) {
          converged = true;
          break;
        }
        changed = true;
      }
      if (!converged) {
        console.warn("[pfand] deposit reconcile did not converge in " + MAX_PASSES + " passes");
      }
      if (!changed) clearFlag(RELOAD_FLAG);
    } catch (error) {
      console.error("[pfand] deposit reconcile failed", error);
    } finally {
      running = false;
    }

    if (changed) {
      if (!onCartPage()) {
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: false } }));
      } else if (readFlag(RELOAD_FLAG) !== "1") {
        writeFlag(RELOAD_FLAG, "1");
        window.location.reload();
        return;
      }
    }

    if (pending) {
      pending = false;
      scheduleReconcile();
    }
  }

  function scheduleReconcile() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reconcile, 60);
  }

  function wireToTheme() {
    const ps = window.FoxTheme && FoxTheme.pubsub;
    if (!ps || typeof ps.subscribe !== "function") return false;
    ps.subscribe(ps.PUB_SUB_EVENTS.cartUpdate, scheduleReconcile);
    reconcile();
    return true;
  }

  if (!wireToTheme()) {
    let tries = 0;
    const poll = setInterval(function () {
      if (wireToTheme() || ++tries > 50) clearInterval(poll);
    }, 100);
  }
})();
